<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/rheinhessen/klaus-peter-keller')">Klaus-Peter Keller
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/rheinhessen/von-buhl')">Von Buhl
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Rheinhessen</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La più grande delle 13 regioni, il vasto e variegato territorio dell'Assia Renana è la regione più grande della Germania. Mentre gran parte degli oltre 26.000 ettari di vigneti sono destinati a uve mediocri per la miscelazione, esiste una piccola regione vinicola pregiata. Chiamata Rheinterrasse (strada del Reno), la bellissima zona è coltivata a vigneti che si innalzano ripidi dalla riva sinistra del Reno.
                        <br>
                        Il Rheinhessen è famoso per la varietà di uve che coltiva, tra cui Sylvaner e Spätburgunder (Pinot Noir), così come l'onnipresente Riesling. Oggi, tuttavia, c'è una maggiore enfasi sulle varietà di altissima qualità (i vini di Peter Keller ne sono un perfetto esempio) e il Riesling è ora la seconda varietà più coltivata nella regione. Keller è anche uno dei pionieri della regione che la sta lentamente allontanando dalla quantità e spostandosi sempre più verso la qualità.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Rheinhessen</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Als größte der 13 Regionen ist Rheinhessen mit seinem weitläufigen, abwechslungsreichen Gelände die größte Region Deutschlands. Während ein Großteil der mehr als 26.000 Hektar Weinberge mittelmäßigen Trauben zum Mischen überlassen werden, gibt es eine kleine Region mit erlesenen Weinen. Das traumhaft schöne Gebiet, auch Rheinterrasse genannt, ist mit Weinbergen bepflanzt, die sich steil vom linken Rheinufer erheben.
                        <br>
                        Rheinhessen ist berühmt für die Vielfalt der dort angebauten Rebsorten, darunter Sylvaner und Spätburgunder (Pinot Noir) sowie den allgegenwärtigen Riesling. Heutzutage wird jedoch mehr Wert auf Sorten höchster Qualität gelegt (die Weine von Peter Keller sind ein perfektes Beispiel), und Riesling ist mittlerweile die am zweithäufigsten angebaute Sorte in der Region. Keller ist auch einer der Pioniere der Region, die langsam von der Quantität weg und immer mehr in Richtung Qualität geht.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Rheinhessen</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La plus grande des 13 régions, le terrain vaste et varié de Rheinhessen est la plus grande région d'Allemagne. Alors qu'une grande partie des plus de 26 000 hectares de vignobles sont consacrés à des raisins médiocres pour l'assemblage, il existe une petite région viticole fine. Appelée Rheinterrasse (rue du Rhin), la belle région étoilée est plantée de vignes qui s'élèvent à pic depuis la rive gauche du Rhin.
                        <br>
                        La Rheinhessen est célèbre pour la variété de raisins qu'elle cultive, notamment le Sylvaner et le Spätburgunder (Pinot Noir), ainsi que l'omniprésent Riesling. Aujourd'hui, cependant, on met davantage l'accent sur les cépages de la plus haute qualité (les vins de Peter Keller en sont un parfait exemple), et le Riesling est désormais le deuxième cépage le plus planté dans la région. Keller est également l'un des pionniers de la région qui l'éloigne lentement de la quantité et s'oriente de plus en plus vers la qualité.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Rheinhessen</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        The largest of the 13 regions, Rheinhessen’s vast, varied terrain is Germany’s largest region. While much of the 26,000-plus hectares of vineyards are given over to mediocre grapes for blending, there is a small fine wine region. Called Rheinterrasse (Rhine street), the starling beautiful area is planted with vineyards that rise steeply from the left bank of the Rhine.
                        <br>
                        The Rheinhessen is famous for the variety of grapes it grows which include Sylvaner and Spätburgunder (Pinot Noir), as well as the ubiquitous Riesling. Today, however, there is greater emphasis on the highest quality varieties (Peter Keller’s wines are a perfect example), and Riesling is now the second-most planted variety in the region. Keller is also one of the pioneers of the region that is slowly leading it away from quantity and moving increasingly towards quality.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Rheinhessen",
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Klaus-Peter Keller', src: '/wine-guide/germany/rheinhessen/klaus-peter-keller'},
                {report: 'Von Buhl', src: '/wine-guide/germany/rheinhessen/von-buhl'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Rheinhessen fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the lush and diverse Rheinhessen wine region, renowned for producing exceptional white and red wines. Explore the unique terroir and sample the flavors of Riesling, Silvaner, and more. Savor the rich history and culture of one of Germany\'s largest wine regions.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
